import React from 'react'
import moment from 'moment'
import { Toggle, ToolTip } from '@driftt/tide-core-legacy'
import { FeatureTooltip } from '@driftt/tide-tooltips-legacy'
import { Link } from 'react-router'

import Tag from 'shared-web/src/components/Tag'
import { ReportTypeToTableName, NEW_EDITOR_PLAYBOOK_TYPES, isLandingPagePlaybook } from 'app/modules/playbook/constants'
import PlaybookEditCell from './PlaybookEditCell'

import './style.styl'

const CLP_AS_PLAYBOOK_RELEASE_TIME = 1554125400161
const CLP_PLAYBOOK_TYPE = "Landing page"

const renderPlaybookNameCell = (playbook, playbookType, playbookId, playbookTag) => (
  <div>
    <div>{PlaybookEditorLink({ playbook })}</div>
    {(playbookType || playbookTag) &&
      <div className="playbook-table-row-name-metadata">
        {playbookTag} {playbookType}
      </div>
    }
  </div>
)

class OutboundPlaybookTooltip extends React.Component {
  componentDidMount() {
    this.props.trackOutboundPlaybookTooltipInteraction({ eventType: 'viewed' })
  }

  render() {
    const {
      trackOutboundPlaybookTooltipInteraction,
      dismissOutboundPlaybookTooltip,
      // canShowOutboundPlaybookTooltip,
      showDefaultWarning,
      updatePlaybookStatus,
      playbook,
      reportType,
      playbookTag,
      isNewType,
    } = this.props

    return (
      // killing this tooltip for the time being until we know what impact it's having
      <FeatureTooltip
        className="outbound-playbook-feature-tooltip"
        onClose={() => {
          trackOutboundPlaybookTooltipInteraction({ eventType: 'dismissed' })
          dismissOutboundPlaybookTooltip()
        }}
        showTooltip={false}
        tooltipSide="right"
        tooltipCaretLocation="bottom"
        headerCopy="Try this message to chat with your email recipients!"
        bodyComponent={
          <p>
            Automatically start conversations with people who click on your emails sent with Drift.{' '}
            <a
              href="https://help.drift.com/article/setting-up-the-outbound-playbook/"
              target="_blank"
              rel="noopener noreferrer"
              className="outbound-playbook-tooltip-learn-more"
            >
              Learn More
            </a>
            {showDefaultWarning && (
              <p className="international-warning">
                <br />
                We noticed your widget isn&rsquo;t in english - we suggest you edit the english defaults in
                this message before you turn it on.
              </p>
            )}
          </p>
        }
        ribbonInfo={{ ribbonCopy: '🌟New!', ribbonColor: 'var(--main-violet)' }}
        mediaComponent={
          <div>
            <img
              className="outbound-playbook-demo-gif"
              src={require('images/gifs/outbound-playbook-demo.gif')}
            />
          </div>
        }
        buttonInfoArray={[
          {
            copy: 'Turn On',
            func: () => {
              trackOutboundPlaybookTooltipInteraction({ eventType: 'clicked', ctaInfo: { type: 'button', color: 'primary', CTA: 'enable playbook', text: 'Turn On' }})
              dismissOutboundPlaybookTooltip()
              updatePlaybookStatus((playbook.status = 'ENABLED'))
            },
          },
          {
            copy: 'Edit Playbook',
            func: () => {
              trackOutboundPlaybookTooltipInteraction({ eventType: 'clicked', ctaInfo: { type: 'button', color: 'secondary', CTA: 'edit playbook', text: 'Edit Playbook' }})
              dismissOutboundPlaybookTooltip()
              window.location.href = isNewType
                ? `/playbooks/editor/${playbook.id}/`
                : `/playbooks/${playbook.id}/edit`
            },
          },
        ]}
      >
        {renderPlaybookNameCell(playbook, ReportTypeToTableName[reportType], playbook.id, playbookTag)}
      </FeatureTooltip>
    )
  }
}

const PlaybookPriorityCell = ({ playbook }, showRowNumberNotPriority = false, paginationInfo) => {
  if (!showRowNumberNotPriority) return <div>{playbook.priority}</div>

  // TODO: remove this and just show priority once the data is fixed on the backend
  const { negative, page, pageSize, index, max } = paginationInfo
  const fakedPriority = negative ? max - (page * pageSize + index) : page * pageSize + (index + 1)
  return <div>{fakedPriority}</div>
}

const PlaybookEditorLink = ({ playbook }) => {
  const isNewType = NEW_EDITOR_PLAYBOOK_TYPES.includes(playbook.reportType)
  const isScheduledPlaybook = playbook.status == 'SCHEDULED'
  return isScheduledPlaybook ? (
    <ToolTip
      flow="right"
      component={
        <div>
          Editing is disabled for this playbook type. <br /> You can archive or delete it to stop from
          sending.
        </div>
      }
    >
      <span> {playbook.name} </span>
    </ToolTip>
  ) : (
    <Link
      className="playbook-table-row-name-content"
      href={isNewType ? `/playbooks/editor/${playbook.id}/` : `/playbooks/${playbook.id}/edit`}
    >
      {playbook.name}
    </Link>
  )
}

const PlaybookNameCell = (
  { playbook },
  updatePlaybookStatus,
  canShowOutboundPlaybookTooltip,
  dismissOutboundPlaybookTooltip,
  showDefaultWarning,
  trackOutboundPlaybookTooltipInteraction
) => {
  const { reportType, id: playbookId } = playbook
  const isAbmPlaybook = reportType === 'ABM'
  const isNewType = NEW_EDITOR_PLAYBOOK_TYPES.includes(playbook.reportType)
  const isOutboundChatPlaybook = reportType === 'TALK_TO_YOUR_OUTBOUND_PROSPECTS'
  let playbookTag = null

  if (isAbmPlaybook) {
    playbookTag = <Tag className="playbook-table-row-name-tag abm-tag" tag={{ name: 'ABM' }} />
  } else if (isOutboundChatPlaybook) {
    playbookTag = <Tag className="playbook-table-row-name-tag outbound-tag" tag={{ name: 'Outbound' }} />
  }
  const hasCLPTag = isLandingPagePlaybook(reportType) && playbook.createdAt > CLP_AS_PLAYBOOK_RELEASE_TIME
  const playbookType = hasCLPTag ? CLP_PLAYBOOK_TYPE : ReportTypeToTableName[reportType]

  return canShowOutboundPlaybookTooltip ? (
    <OutboundPlaybookTooltip
      trackOutboundPlaybookTooltipInteraction={trackOutboundPlaybookTooltipInteraction}
      dismissOutboundPlaybookTooltip={dismissOutboundPlaybookTooltip}
      canShowOutboundPlaybookTooltip={canShowOutboundPlaybookTooltip}
      showDefaultWarning={showDefaultWarning}
      updatePlaybookStatus={updatePlaybookStatus}
      playbook={playbook}
      reportType={reportType}
      playbookTag={playbookTag}
      isNewType={isNewType}
    />
  ) : (
    renderPlaybookNameCell(playbook, playbookType, playbookId, playbookTag)
  )
}

const PlaybookIdCell = ({ playbook: { id: playbookId }}) => (
  <div>
    {playbookId}
  </div>
)

const PlaybookLastUpdatedCell = ({ playbook }, orgUsers) => {
  const lastUpdatedBy = orgUsers.get(playbook.updatedAuthorId || playbook.createdAuthorId)

  return (
    <div>
      <div>
        {moment(playbook.updatedAt).format('ll')}
      </div>
      {lastUpdatedBy &&
        <div className="playbook-table-row-last-update-by">by {(lastUpdatedBy.name || lastUpdatedBy.email)}</div>
      }
    </div>
  )
}

const PlaybookScheduledForCell = ({ playbook }) => (
  <div>{moment(playbook.targeting.dueAt).format('lll')}</div>
)

const PlaybookStatusCell = (playbookData, toggleEnablePlaybookModal) => {
  if (!['ENABLED', 'DISABLED'].includes(playbookData.playbook.status)) return <div />
  return (
    <div>
      <Toggle
        className={'playbook-table-row-status-toggle'}
        checked={playbookData.playbook.status === 'ENABLED'}
        onChange={() => toggleEnablePlaybookModal(playbookData)}
      />
    </div>
  )
}

export const playbookRowFactory = ({
  playbookData,
  tableState = 'CHAT_ACTIVE',
  toggleEnablePlaybookModal,
  onDropdownActionClick,
  getIsActionLoading,
  showRowNumberNotPriority,
  paginationInfo,
  orgUsers,
  playbookReportTypePlans,
  canShowOutboundPlaybookTooltip,
  dismissOutboundPlaybookTooltip,
  updatePlaybookStatus,
  showDefaultWarning,
  trackOutboundPlaybookTooltipInteraction
}) => {
  const editCellComponent = (
    <PlaybookEditCell
      playbookData={playbookData}
      onDropdownActionClick={onDropdownActionClick}
      playbookReportTypePlans={playbookReportTypePlans}
      getIsActionLoading={getIsActionLoading}/>
  )

  const playbookToRowMap = {
    CHAT_ACTIVE: (p) => ({ data:[
      { content: PlaybookPriorityCell(p, showRowNumberNotPriority, paginationInfo) },
      {
        content: PlaybookNameCell(
          p,
          updatePlaybookStatus,
          canShowOutboundPlaybookTooltip,
          dismissOutboundPlaybookTooltip,
          showDefaultWarning,
          trackOutboundPlaybookTooltipInteraction
        ),
      },
      { content: editCellComponent, className: 'playbook-table-edit-cell' },
      { content: PlaybookIdCell(p), className: 'playbook-table-cell-id' },
      { content: PlaybookLastUpdatedCell(p, orgUsers), className: 'playbook-table-last-updated-cell' },
      { content: PlaybookStatusCell(p, toggleEnablePlaybookModal), className: 'playbook-table-status-cell' },
    ]}),
    CHAT_ARCHIVED: (p) => ({ data: [
      { content: PlaybookNameCell(p) },
      { content: editCellComponent, className: 'playbook-table-edit-cell' },
      { content: PlaybookIdCell(p), className: 'playbook-table-cell-id' },
      { content: PlaybookLastUpdatedCell(p, orgUsers), className: 'playbook-table-last-updated-cell' },
    ]}),
    EMAIL_ACTIVE: (p) => ({ data: [
      { content: PlaybookNameCell(p) },
      { content: editCellComponent, className: 'playbook-table-edit-cell' },
      { content: PlaybookIdCell(p), className: 'playbook-table-cell-id' },
      { content: PlaybookLastUpdatedCell(p, orgUsers), className: 'playbook-table-last-updated-cell' },
      { content: PlaybookStatusCell(p, toggleEnablePlaybookModal), className: 'playbook-table-status-cell' },
    ]}),
    EMAIL_SCHEDULED: (p) => ({ data: [
      { content: PlaybookNameCell(p) },
      { content: editCellComponent, className: 'playbook-table-edit-cell' },
      { content: PlaybookIdCell(p), className: 'playbook-table-cell-id' },
      { content: PlaybookLastUpdatedCell(p, orgUsers), className: 'playbook-table-last-updated-cell' },
      { content: PlaybookScheduledForCell(p), className: 'playbook-table-last-updated-cell' },
    ]}),
    EMAIL_SENT: (p) => ({ data: [
      { content: PlaybookNameCell(p) },
      { content: editCellComponent, className: 'playbook-table-edit-cell' },
      { content: PlaybookIdCell(p), className: 'playbook-table-cell-id' },
      { content: PlaybookLastUpdatedCell(p, orgUsers), className: 'playbook-table-last-updated-cell' },
    ]}),
    EMAIL_DRAFTS: (p) => ({ data: [
      { content: PlaybookNameCell(p) },
      { content: editCellComponent },
      { content: PlaybookIdCell(p), className: 'playbook-table-cell-id' },
      { content: PlaybookLastUpdatedCell(p, orgUsers), className: 'playbook-table-last-updated-cell' },
    ]}),
    EMAIL_ARCHIVED: (p) => ({ data: [
      { content: PlaybookNameCell(p) },
      { content: editCellComponent, className: 'playbook-table-edit-cell' },
      { content: PlaybookIdCell(p), className: 'playbook-table-cell-id' },
      { content: PlaybookLastUpdatedCell(p, orgUsers), className: 'playbook-table-last-updated-cell' },
    ]}),
    SEQUENCE_ARCHIVED: (p) => ({ data: [
      { content: PlaybookNameCell(p) },
      { content: editCellComponent, className: 'playbook-table-edit-cell' },
      { content: PlaybookIdCell(p), className: 'playbook-table-cell-id' },
      { content: PlaybookLastUpdatedCell(p, orgUsers), className: 'playbook-table-last-updated-cell' },
    ]}),
    SEQUENCE_DRAFTS: (p) => ({ data: [
      { content: PlaybookNameCell(p) },
      { content: editCellComponent, className: 'playbook-table-edit-cell' },
      { content: PlaybookIdCell(p), className: 'playbook-table-cell-id' },
      { content: PlaybookLastUpdatedCell(p, orgUsers), className: 'playbook-table-last-updated-cell' },
    ]}),
    SEQUENCE_ACTIVE: (p) => ({ data: [
      { content: PlaybookNameCell(p) },
      { content: editCellComponent, className: 'playbook-table-edit-cell' },
      { content: PlaybookIdCell(p), className: 'playbook-table-cell-id' },
      { content: PlaybookLastUpdatedCell(p, orgUsers), className: 'playbook-table-last-updated-cell' },
      { content: PlaybookStatusCell(p, toggleEnablePlaybookModal), className: 'playbook-table-status-cell' },
    ]}),
    SIGNATURE_ACTIVE: (p) => ({ data: [
      { content: PlaybookNameCell(p) },
      { content: editCellComponent, className: 'playbook-table-edit-cell' },
      { content: PlaybookIdCell(p), className: 'playbook-table-cell-id' },
      { content: PlaybookLastUpdatedCell(p, orgUsers), className: 'playbook-table-last-updated-cell' },
      { content: PlaybookStatusCell(p, toggleEnablePlaybookModal), className: 'playbook-table-status-cell' },
    ]}),
    SIGNATURE_ARCHIVED: (p) => ({ data: [
      { content: PlaybookNameCell(p) },
      { content: editCellComponent, className: 'playbook-table-edit-cell' },
      { content: PlaybookIdCell(p), className: 'playbook-table-cell-id' },
      { content: PlaybookLastUpdatedCell(p, orgUsers), className: 'playbook-table-last-updated-cell' },
    ]})
  }

  return playbookToRowMap[tableState](playbookData)
}



// WEBPACK FOOTER //
// ./src/scripts/components/PlaybookList/PlaybooksTableRow/index.js